
function Footer() {

    return (
        <footer className=" text-center text-lg-start mt-4">
            <div className="text-center p-3">
                <div id="footer-text">© 2026 Emil Øgård</div>
            </div>
        </footer>
    );
}

export default Footer;